import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";

import InvoiceTemplate from "./InvoiceTemplate";

const InvoicePreviewModal = ({
    open,
    onClose,
    invoice
}) => {

    if(!invoice) return null;

    return(

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
        >

            <DialogTitle>

                Invoice Preview

                <IconButton
                    style={{
                        position:"absolute",
                        right:15,
                        top:10
                    }}
                    onClick={onClose}
                >
                    <CloseIcon/>
                </IconButton>

            </DialogTitle>

            <DialogContent
                style={{
                    background:"#eee",
                    maxHeight:"90vh",
                    overflowY:"auto"
                }}
            >

                <InvoiceTemplate
                    invoice={invoice}
                />

            </DialogContent>

        </Dialog>

    )

}

export default InvoicePreviewModal;